import {ClientsModel} from "../clients.model";

export type DuplicateCheckField =
    | 'full_name'
    | 'pseudonym'
    | 'phone'
    | 'email'
    | 'inn'
    | 'current_address'
    | 'company';

export interface DuplicateCheckPayload {
    full_name: string;
    pseudonym: string;
    phone: string;
    email: string;
    inn: string;
    current_address: string;
    company: string;
}

export const DUPLICATE_CHECK_FIELD_ORDER: DuplicateCheckField[] = [
    'full_name',
    'pseudonym',
    'phone',
    'email',
    'inn',
    'current_address',
    'company',
];

export const DEFAULT_DUPLICATE_CHECK_FIELDS: DuplicateCheckField[] = ['full_name', 'inn'];

export const DUPLICATE_CHECK_FIELD_LABELS: Record<DuplicateCheckField, string> = {
    full_name: 'ФИО',
    pseudonym: 'Псевдоним',
    phone: 'Телефон',
    email: 'Email',
    inn: 'ИНН',
    current_address: 'Адрес',
    company: 'Компания',
};

export const DUPLICATE_CHECK_FIELD_OPTIONS = DUPLICATE_CHECK_FIELD_ORDER.map((field) => ({
    value: field,
    label: DUPLICATE_CHECK_FIELD_LABELS[field],
}));

export const createEmptyDuplicateCheckPayload = (): DuplicateCheckPayload => ({
    full_name: '',
    pseudonym: '',
    phone: '',
    email: '',
    inn: '',
    current_address: '',
    company: '',
});

export const normalizeDuplicateCheckFields = (fields?: string[] | null): DuplicateCheckField[] => {
    const allowedFields = new Set<DuplicateCheckField>(DUPLICATE_CHECK_FIELD_ORDER);
    const selectedFields = new Set<DuplicateCheckField>();

    (fields || []).forEach((field) => {
        if (allowedFields.has(field as DuplicateCheckField)) {
            selectedFields.add(field as DuplicateCheckField);
        }
    });

    return DUPLICATE_CHECK_FIELD_ORDER.filter((field) => selectedFields.has(field));
}

export const getEffectiveDuplicateCheckFields = (fields?: string[] | null): DuplicateCheckField[] => {
    const normalizedFields = normalizeDuplicateCheckFields(fields);
    return normalizedFields.length > 0 ? normalizedFields : DEFAULT_DUPLICATE_CHECK_FIELDS;
}

export const getDuplicateCheckFieldLabel = (field: string) => {
    return DUPLICATE_CHECK_FIELD_LABELS[field as DuplicateCheckField] || field;
}

export const buildDuplicatePayloadFromClientForm = (form: ClientsModel): DuplicateCheckPayload => ({
    full_name: form.full_name || '',
    pseudonym: form.pseudonym || '',
    phone: form.phone || '',
    email: form.email || '',
    inn: form.inn || '',
    current_address: form.current_address || '',
    company: form.company || '',
});

export const hasDuplicatePayloadValues = (
    payload: DuplicateCheckPayload,
    fields: DuplicateCheckField[],
) => {
    return fields.some((field) => payload[field]?.trim() !== '');
}

export const hasRealtimeDuplicatePayloadValues = (
    payload: DuplicateCheckPayload,
    fields: DuplicateCheckField[],
) => {
    return fields.some((field) => {
        const value = payload[field]?.trim() || '';
        if (value === '') {
            return false;
        }

        if (field === 'phone' || field === 'inn') {
            return value.length >= 3;
        }

        return value.length >= 2;
    });
}
